<ng-container *ngIf="!isIfp">
  <div class="mt-4 pb-1">
    <strong>{{ 'drugNameSearch.additional_info' | translate }}</strong>
  </div>
  <div class="row pl-3 pt-2">
    <div class="mb-2 mr-4" *ngFor="let item of nonIFPPdf; let last = last">
      <small class="pdf-icon mr-2">
        <label [innerHTML]="item" class="pr-4"></label>
        <span *ngIf="!last" class="spacer-grey"></span>
      </small>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isIfp">
  <div class="mt-4 pb-1">
    <a
      target="_blank"
      href="https://www.cigna.com/individuals-families/member-resources/prescription/"
      >Prescription Drug List and Coverage Info</a
    >
  </div>
</ng-container>
